export default __webpack_public_path__ + "static/media/Linkedin Learning Programing Foundations_ DataBases.f631fa26.webp";